var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "position_list border-line py-[10px]"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.position.id,
      expression: "position.id"
    }],
    staticClass: "h-full flex flex-col gap-[20px]",
    attrs: {
      "id": "position_list_content"
    }
  }, [_c('div', {
    staticClass: "title_action px-4",
    attrs: {
      "id": "title_action"
    }
  }, [_c('div', [_c('b', {
    staticClass: "text-[16px]"
  }, [_vm._v(_vm._s(_vm.position.tagName))])]), _vm.isAdmin ? _c('div', {
    staticClass: "flex gap-[10px] items-center"
  }, [_c('Poptip', {
    attrs: {
      "confirm": "",
      "title": $t("e9nrhy5", "确定移除？"),
      "placement": "bottom-end"
    },
    on: {
      "on-ok": _vm.onDelete
    }
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm._buttonShow,
      expression: "_buttonShow"
    }],
    staticClass: "buttons",
    attrs: {
      "type": "error"
    }
  }, [_vm._v(` ${$t("lknd2", "移除")} `)])], 1), _c('Button', {
    staticClass: "buttons",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onOpen
    }
  }, [_vm._v(` ${$t("9b9psi7", "添加部门/成员")} `)])], 1) : _vm._e()]), _c('pro-table', _vm._b({
    on: {
      "table:on-selection-change": _vm.onOnSelectionChange
    }
  }, 'pro-table', _vm.config, false))], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.position.id,
      expression: "!position.id"
    }],
    staticClass: "text-center mt-[150px] text-[20px]"
  }, [_c('div', [_c('Icon', {
    staticClass: "text-[#eee]",
    attrs: {
      "size": 200,
      "type": "md-pricetag"
    }
  })], 1), _c('div', {
    staticClass: "mb-[20px]"
  }, [_vm._v($t("47g6lwc", "暂无可选岗位，请添加岗位"))]), _c('Button', {
    on: {
      "click": _vm.onAddPosition
    }
  }, [_vm._v($t("e7xisb4", "添加岗位"))])], 1), _c('PositionStructureAdd', {
    attrs: {
      "position": _vm.position
    },
    on: {
      "onSuccess": _vm.onSearchStatr
    },
    model: {
      value: _vm.structure.visible,
      callback: function ($$v) {
        _vm.$set(_vm.structure, "visible", $$v);
      },
      expression: "structure.visible"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };